import { render } from "./ObjectsNav.vue?vue&type=template&id=f28b1d9c"
import script from "./ObjectsNav.vue?vue&type=script&lang=js"
export * from "./ObjectsNav.vue?vue&type=script&lang=js"

import "./ObjectsNav.vue?vue&type=style&index=0&id=f28b1d9c&lang=scss"
import "./ObjectsNav.vue?vue&type=style&index=1&id=f28b1d9c&lang=scss"

import exportComponent from "/app/tmp/aft/V3/v2026.13.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__